import { VBrick360Viewer } from './VBrick360Viewer';

import styles from './Vg360.module.less';

export class VBrick360MouseHelper {
	private onMouseDownCoords: { lat: number; lon: number; x: number; y: number };

	constructor(
		private viewer: VBrick360Viewer,
		private document: Document
	) {
		this.viewer.domElement.addEventListener('mousedown', this.onMouseDown);
	}

	public destroy(): void {
		this.viewer.domElement.removeEventListener('mousedown', this.onMouseDown);

		this.removeDocumentBindings();
	}

	private onMouseDown = (event: MouseEvent): void => {
		event.preventDefault();

		this.document.addEventListener('mousemove', this.onMouseMove);
		
		this.document.addEventListener('mouseup', this.onMouseUp);

		this.viewer.domElement.classList.add(styles.mouseDown);

		const currentCoords = this.viewer.currentCoordinates;

		this.onMouseDownCoords = {
			lat: currentCoords.lat,
			lon: currentCoords.lon,
			x: event.clientX,
			y: event.clientY
		};
	};

	private onMouseMove = (event: MouseEvent): void => {
		this.viewer.setCoordinates(
			(this.onMouseDownCoords.y - event.clientY) * 0.1 + this.onMouseDownCoords.lat,
			(this.onMouseDownCoords.x - event.clientX) * 0.1 + this.onMouseDownCoords.lon
		);
	};

	private onMouseUp = (): void => {
		this.removeDocumentBindings();

		this.viewer.domElement.classList.remove(styles.mouseDown);
	}

	private removeDocumentBindings(): void {
		this.document.removeEventListener('mousemove', this.onMouseMove);
		this.document.removeEventListener('mouseup', this.onMouseUp);
	}
}
